import React from 'react'

type GetSpeedTimeInMilliSecond = (second?: number) => number
export const getSpeedTimeInMilliSecond: GetSpeedTimeInMilliSecond = (speed = 5) => speed * 1000

type GetNextImageIndex = (maxLength: number) => (current: number) => number
export const getNextImageIndex: GetNextImageIndex = (maxLength) => (current) => {
    return maxLength > current ? current + 1 : 0
}

type SetAutoPlaySlider = (
    setActive: React.Dispatch<React.SetStateAction<number>>,
    maxLength: number,
    intervalTime: number
) => NodeJS.Timer
export const setAutoplaySlider: SetAutoPlaySlider = (setActive, maxLength, intervalTime) => {
    return setInterval(() => {
        setActive(getNextImageIndex(maxLength))
    }, intervalTime)
}

type HandleThumbClick = ({
    setActive,
    index,
    intervalId,
    setIntervalId,
    intervalTime,
    maxlength,
    autoplay,
}: {
    setActive: React.Dispatch<React.SetStateAction<number>>
    index: number
    intervalId: NodeJS.Timer | undefined
    setIntervalId: (time: NodeJS.Timer) => void
    intervalTime: number
    maxlength: number
    autoplay: boolean
}) => () => void

export const handleThumbClick: HandleThumbClick =
    ({ setActive, index, intervalId, maxlength, autoplay, intervalTime, setIntervalId }) =>
    () => {
        setActive(index)
        intervalId && clearInterval(intervalId)
        if (autoplay) {
            const time = setAutoplaySlider(setActive, maxlength, intervalTime)
            setIntervalId(time)
        }
    }
